export default {
      id: "waze-usage",
      viewBox: "0 0 52 52",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#waze-usage",
      toString: function () {
        return this.url;
      }
    }